
import Vue from 'vue'

const getDefaultState = () => {
    return {
        todayschedule: {
            id: 0,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`today-schedule/list`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listTodaySchedule = result.data.result;

                return listTodaySchedule;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list today schedules: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`today-schedule/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get todayschedule`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get todayschedule: [${ex}]`
            };
        }
    },

    async GetByDate(_, dateSchedule) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`today-schedule/get-by-date/${dateSchedule}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get todayschedule`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get todayschedule: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, todayscheduleRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`today-schedule/create-update`, todayscheduleRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (todayscheduleRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    idTodaySchedule: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    idTodaySchedule: 0,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async ApproveOrDeny(_, approveOrDenyRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`today-schedule/approve-deny`, approveOrDenyRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                return {
                    success: true,
                    message: "Updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    idTodaySchedule: 0,
                    message: "Error to update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to update register: [${error}]`
                };
            }
        }
    },
    
    async SendEmailToUsers() {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`today-schedule/send-email-to-users`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "E-mail to users sent with successfully!";

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to send e-mail to users!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to send email to users: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to send email to users: [${error}]`
                };
            }
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.todayschedule, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.todayschedule;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
